export default !!(typeof navigator !== 'undefined' &&
  /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent ?? ''))
